import React from 'react';
import { IconProps } from '../types/Icon';

export default function EmailSentIcon({ height = 16, width = 15, colour = '#FFFFFF' }: IconProps) {
    return (
        <svg
            width="223"
            height="104"
            viewBox="0 0 223 104"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <line
                x1="87"
                y1="30"
                x2="61"
                y2="30"
                stroke="url(#paint0_linear_12_18741)"
                strokeWidth="4"
            />
            <line
                x1="87"
                y1="54"
                x2="-1.74846e-07"
                y2="54"
                stroke="url(#paint1_linear_12_18741)"
                strokeWidth="4"
            />
            <line
                x1="87"
                y1="78"
                x2="27"
                y2="78"
                stroke="url(#paint2_linear_12_18741)"
                strokeWidth="4"
            />
            <path
                d="M217.85 89.5L176 52M140 52L98.1502 89.5M95 20.75L146.439 56.4715C150.604 59.3641 152.687 60.8105 154.952 61.3707C156.954 61.8655 159.046 61.8655 161.048 61.3707C163.313 60.8105 165.396 59.3641 169.561 56.4715L221 20.75M125.24 102H190.76C201.345 102 206.637 102 210.68 99.9564C214.237 98.1587 217.128 95.2904 218.94 91.7623C221 87.7515 221 82.501 221 72V32C221 21.499 221 16.2485 218.94 12.2377C217.128 8.70964 214.237 5.84125 210.68 4.04363C206.637 2 201.345 2 190.76 2H125.24C114.655 2 109.363 2 105.32 4.04363C101.763 5.84125 98.872 8.70964 97.06 12.2377C95 16.2485 95 21.499 95 32V72C95 82.501 95 87.7515 97.06 91.7623C98.872 95.2904 101.763 98.1587 105.32 99.9564C109.363 102 114.655 102 125.24 102Z"
                stroke="#0080FF"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_12_18741"
                    x1="61"
                    y1="27.5"
                    x2="87"
                    y2="27.5"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#004D99" />
                    <stop
                        offset="1"
                        stopColor="#0080FF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_12_18741"
                    x1="4.37114e-08"
                    y1="51.5"
                    x2="87"
                    y2="51.5"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#004D99" />
                    <stop
                        offset="1"
                        stopColor="#0080FF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_12_18741"
                    x1="27"
                    y1="75.5"
                    x2="87"
                    y2="75.5"
                    gradientUnits="userSpaceOnUse">
                    <stop stopColor="#004D99" />
                    <stop
                        offset="1"
                        stopColor="#0080FF"
                    />
                </linearGradient>
            </defs>
        </svg>
    );
}
